// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4b-2";
export var blackBorderOnHover = "_4b-7";
export var cell = "_4b-6";
export var cellContainer = "_4b-3";
export var checked = "_4b-8";
export var disabled = "_4b-5";
export var featuredIconCellContainer = "_4b-9";
export var featuredIconTextContainer = "_4b-b";
export var featuredIconWrapper = "_4b-a";
export var noBorder = "_4b-c";
export var orangeSelectedRow = "_bz-3";
export var overflowableText = "_4b-0";
export var overflowableTextContainer = "_4b-1";
export var row = "_4c-0";
export var rowCheckboxCell = "_4b-4";
export var selectableTable = "_bz-2";